import React, {useEffect, useRef, useState} from 'react';
import Translate, {t} from 'components/Translate';
import TranslateProperty from 'components/TranslateProperty';
import {
    addCompanyCategory,
    addCompanyInitialMessage,
    addSkill,
    addTemplate,
    deleteCompanyCategory,
    deleteCompanyInitialMessage,
    deleteSkill,
    deleteTemplate,
    editCompanyCategory,
    editCompanyInitialMessage,
    editTemplate,
    getCompanyCategories,
    getCompanyInitialMessage,
    getSkills,
    getTemplates,
    getWebhooks,
    importTemplatesF,
    updateSkill
} from '../../../../../../services/company/api';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import config from "../../../../../../config";
import BlueButton from "../../../../../../components-new/buttons/BlueButton";
import Input from "../../../../../../components-new/Input";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import Separator from "../../../../../../assets/Separator";
import FolderIcon from "../../../../../../assets/images/folder.png"
import {confirmActionRequested} from "../../../../../../services/confirmAction/action";
import {connect} from "react-redux";
import TemplatesViewModal from "../../../../../../components-new/TemplatesViewModal";
import Webhooks from "./functions/Webhooks";
import {silverInfoStyles, tabButtonStyles} from "../../../../../../utils/General";
import ImportTemplates from "./resources/ImportTemplates";

function Resources({tariff, client, confirmAction, user, clients}) {
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState('');
    const [visibleCategories, setVisibleCategories] = useState({});
    const [templates, setTemplates] = useState([]);
    const [editingTemplateId, setEditingTemplateId] = useState();
    const [newTemplate, setNewTemplate] = useState('');
    const [newTemplateFolderName, setNewTemplateFolderName] = useState();
    const [skills, setSkills] = useState([]);
    const [newSkill, setNewSkill] = useState('');
    const [webhooks, setWebhooks] = useState([]);
    const [updateWebhooksState, setUpdateWebhooksState] = useState(false);
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [editIndex, setEditIndex] = useState(-1);
    const [editId, setEditId] = useState(-1);
    const [visibleMessages, setVisibleMessages] = useState({});
    const {features} = tariff
    const [activeTab, setActiveTab] = useState('initialMessages');
    const inputRef = useRef(null);

    useEffect(() => {
        getCompanyInitialMessage(client.id).then((data) => {
            setMessages(data);
            data.map(d => {
                if (d.enabled) {
                    visibleMessages[d.id] = d;
                }
            });
        });
        getCompanyCategories(client.id).then((data) => {
            setCategories(data);
            const initialVisibleState = {};
            data.forEach(category => {
                initialVisibleState[category.name] = category.enabled;
            });
            setVisibleCategories(initialVisibleState);
        });

        getTemplates(client.id).then((data) => {
            setTemplates(data);
        });

        getSkills(client.id).then((data) => {
            setSkills(data);
        });

        getWebhooks(client.id).then(setWebhooks);

    }, [client.id]);

    useEffect(() => {
        getWebhooks(client.id).then(setWebhooks);
    }, [updateWebhooksState]);

    const handleInputChange = (event) => setNewCategory(event.target.value);

    const handleAddCategory = () => {
        if (newCategory.trim()) {
            addCompanyCategory(client.id, newCategory).then(data => {
                setCategories([...categories, {name: newCategory}]);
                setVisibleCategories({...visibleCategories, [newCategory]: true});
                setNewCategory('');
            });
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') handleAddCategory();
    };

    const handleDeleteCategory = (index, categoryName) => {
        const updatedCategories = [...categories];
        updatedCategories.splice(index, 1);
        setCategories(updatedCategories);
        const {[categoryName]: _, ...updatedVisibleCategories} = visibleCategories;
        setVisibleCategories(updatedVisibleCategories);
        deleteCompanyCategory(client.id, categoryName);
    };

    const toggleCategoryVisibility = (name, id) => {
        setVisibleCategories(prevVisibleCategories => ({
            ...prevVisibleCategories,
            [name]: !prevVisibleCategories[name]
        }));
        editCompanyCategory(client.id, id, !visibleCategories[name]);
    };

    const handleTemplateInputChange = (event) => setNewTemplate(event.target.value);

    const handleTemplateFolderInputChange = (event) => setNewTemplateFolderName(event.target.value);

    const handleSaveTemplate = () => {
        if (newTemplate.trim()) {
            if (editingTemplateId) {
                editTemplate(client.id, newTemplate, newTemplateFolderName, editingTemplateId).then((data) => {
                    setTemplates(templates.map(template =>
                        template.id === editingTemplateId
                            ? {...template, text: newTemplate, folderName: newTemplateFolderName}
                            : template
                    ));
                    setNewTemplate('');
                    setNewTemplateFolderName('');
                    setEditingTemplateId(undefined)
                });
            } else {
                addTemplate(client.id, newTemplate, newTemplateFolderName).then((data) => {
                    setTemplates([...templates, {id: data.id, text: newTemplate, folderName: data.folderName}]);
                    setNewTemplate('');
                    setNewTemplateFolderName('');
                    setEditingTemplateId(undefined)
                });
            }
        }
    };

    const handleImportTemplate = (originalCompanyId, folderName) => {
        importTemplatesF(client.id, originalCompanyId, folderName).then(() => {
            getTemplates(client.id).then((data) => {
                setTemplates(data);
            });
        });
    };

    const handleDeleteTemplate = (templateId) => {
        deleteTemplate(client.id, templateId).then(() => {
            setTemplates(templates.filter(template => template.id !== templateId));
        });
    };

    const handleEditTemplate = (templateId) => {
        setEditingTemplateId(templateId)
        setNewTemplate(templates.filter(t => t.id === templateId)[0].text)
        setNewTemplateFolderName(templates.filter(t => t.id === templateId)[0].folderName)
    };

    const handleSkillInputChange = (event) => setNewSkill(event.target.value);

    const handleAddSkill = () => {
        if (newSkill.trim()) {
            addSkill(client.id, newSkill).then((data) => {
                setSkills([...skills, {id: data.id, name: newSkill}]);
                setNewSkill('');
            });
        }
    };

    const handleDeleteSkill = (skillId) => {
        deleteSkill(client.id, skillId).then(() => {
            setSkills(skills.filter(skill => skill.id !== skillId));
        });
    };

    const handleUpdateSkill = (skillId, updatedName) => {
        updateSkill(client.id, skillId, updatedName).then(() => {
            setSkills(skills.map(skill =>
                skill.id === skillId ? {...skill, name: updatedName} : skill
            ));
        });
    };

    const groupedTemplates = templates.reduce((acc, template) => {
        if (!acc[template.folderName]) acc[template.folderName] = [];
        acc[template.folderName].push(template);
        return acc;
    }, {});

    const handleTemplateFolderClick = (templates, folderName) => {
        confirmAction({
            content: <TemplatesViewModal handleDeleteTemplate={handleDeleteTemplate} folderName={folderName}
                                         handleEditTemplate={handleEditTemplate} templates={templates}/>
        })
    }

    const handleInitialMessageKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleAddOrSaveMessage();
        }
    };

    const handleEditMessage = (index, id) => {
        setNewMessage(messages[index].text);
        setEditIndex(index);
        setEditId(id);
    };

    const handleDeleteMessage = (index, id) => {
        const messageToDelete = messages[index];
        const updatedMessages = messages.filter((_, idx) => idx !== index);
        setMessages(updatedMessages);

        const {[messageToDelete.id]: _, ...updatedVisibleMessages} = visibleMessages;
        setVisibleMessages(updatedVisibleMessages);

        deleteCompanyInitialMessage(id, client.id);
    };

    const toggleMessageVisibility = (message, bool) => {
        setMessages(prevMessages =>
            prevMessages.map(msg =>
                msg.id === message.id ? {...msg, enabled: bool} : msg
            )
        );
        const id = message.id;
        setVisibleMessages(prevVisibleMessages => ({
            ...prevVisibleMessages,
            [id]: !prevVisibleMessages[id]
        }));
        const initialMessage = {
            id: id,
            companyId: client.id,
            text: message.text,
            enabled: !message.enabled
        };
        editCompanyInitialMessage(initialMessage, client.id);
    };

    const handleInitialMessageInputChange = (event) => {
        setNewMessage(event.target.value);
    };

    const handleAddOrSaveMessage = () => {
        if (newMessage.trim() !== '') {
            if (editIndex >= 0) {
                const updatedMessages = [...messages];
                updatedMessages[editIndex].text = newMessage;
                setMessages(updatedMessages);
                setEditIndex(-1);

                const initialMessage = {
                    id: editId,
                    companyId: client.id,
                    text: newMessage,
                    enabled: true
                };
                visibleMessages[editId] = initialMessage;
                editCompanyInitialMessage(initialMessage, client.id);
            } else {
                const initialMessage = {
                    companyId: client.id,
                    text: newMessage,
                    enabled: true
                };
                addCompanyInitialMessage(initialMessage, client.id).then((data) => {
                    const newMessageObject = {id: data.id, text: newMessage, enabled: true};
                    const newMessages = [...messages, newMessageObject];
                    setMessages(newMessages);
                    setVisibleMessages({...visibleMessages, [newMessageObject.id]: true});
                });
            }
            setNewMessage('');
        }
    };

    return (
        <div>

            <div style={tabButtonStyles.tabButtons}>
                {features.includes(config.features.INITIAL_MESSAGES) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'initialMessages')}
                            onClick={() => setActiveTab('initialMessages')}>
                        <Translate text="initialMessages"/>
                    </button>
                )}

                {features.includes(config.features.TEMPLATES) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'templates')}
                            onClick={() => setActiveTab('templates')}>
                        <Translate text="templates"/>
                    </button>
                )}

                {features.includes(config.features.CATEGORIES) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'categories')}
                            onClick={() => setActiveTab('categories')}>
                        <Translate text="categories"/>
                    </button>
                )}

                {features.includes(config.features.SKILLS) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'skills')}
                            onClick={() => setActiveTab('skills')}>
                        <Translate text="skills"/>
                    </button>
                )}

                {features.includes(config.features.WEBHOOKS) && (
                    <button style={tabButtonStyles.tabButton(activeTab === 'webhooks')}
                            onClick={() => setActiveTab('webhooks')}>
                        <Translate text="webhooks"/>
                    </button>
                )}
            </div>

            {features.includes(config.features.INITIAL_MESSAGES) && activeTab === 'initialMessages' &&
                <div className="bg-white">
                    <div className="first-messages-block">
                        <h2 className="configurations-header">
                            <Translate text="initialMessages"/>
                        </h2>
                        <div style={{
                            ...silverInfoStyles.info,
                            marginLeft: '0px',
                            marginBottom: '20px',
                            textAlign: 'center'
                        }}>
                            <Translate text="initialMessagesExplanation"/>
                        </div>
                        <Input
                            isTextarea={true}
                            placeholder={t({text: "enterInitialMessageHere", user})}
                            value={newMessage}
                            onChange={handleInitialMessageInputChange}
                            onKeyPress={handleInitialMessageKeyPress}
                        />
                        <br/>
                        <BlueButton
                            height={'43px'}
                            styles={{
                                fontSize:'11px',
                                marginLeft: '10px',
                            }}
                            width={'140px'}
                            children={<Translate text={editIndex >= 0 ? 'save' : 'add'}/>}
                            onClick={handleAddOrSaveMessage}
                        />
                        <div className="messages-row" style={{maxHeight: '500px', overflow: 'auto'}}>
                            {messages.length === 0 ? (
                                <p></p>
                            ) : (
                                messages.map((message, index) => (
                                    <div
                                        className="message-block"
                                        key={message.id}
                                        style={{
                                            opacity: message.enabled ? 1 : 0.5,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '10px',
                                            borderRadius: '8px',
                                            marginBottom: '10px',
                                            minHeight: '60px',
                                            maxHeight: '60px',
                                            width: '100%',
                                        }}
                                    >
                                        <div
                                            title={message.text}
                                            style={{
                                                flex: 1,
                                                marginRight: '20px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '100%',
                                            }}
                                        >
                                            {message.text}
                                        </div>

                                        <label className="switch" style={{marginRight: '10px'}}>
                                            <input
                                                type="checkbox"
                                                checked={message.enabled}
                                                onChange={() => toggleMessageVisibility(message, !message.enabled)}
                                            />
                                            <span className="slider round"></span>
                                        </label>

                                        <button
                                            className="edit-btn"
                                            onClick={() => handleEditMessage(index, message.id)}
                                            style={{marginRight: '5px'}}
                                        >
                                            ✎
                                        </button>
                                        <button
                                            className="remove-btn"
                                            onClick={() => handleDeleteMessage(index, message.id)}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))

                            )}
                        </div>
                    </div>
                </div>
            }

            {features.includes(config.features.TEMPLATES) && activeTab === 'templates' && (
                <div className={'bg-white'}>
                    <div className="first-messages-block">

                        <div>
                            <h2 style={{padding: '10px'}} className="configurations-header">
                                <Translate text={'templates'}/>
                            </h2>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'templateText'}]}>
                                <Input
                                    isTextarea={true}
                                    maxLength={10000}
                                    type="text"
                                    value={newTemplate}
                                    onChange={handleTemplateInputChange}
                                    style={{
                                        padding: '10px',
                                        height: '200px',
                                        margin: '10px'
                                    }}
                                />
                            </TranslateProperty>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'folderName'}]}>
                                <Input
                                    ref={inputRef}
                                    maxLength={40}
                                    type="text"
                                    value={newTemplateFolderName}
                                    onChange={handleTemplateFolderInputChange}
                                    style={{
                                        padding: '10px',
                                        margin: '10px',
                                    }}
                                />
                            </TranslateProperty>
                            <BlueButton
                                height={'43px'}
                                styles={{
                                    fontSize:'11px',
                                    marginLeft: '10px',
                                }}
                                width={'140px'}
                                onClick={handleSaveTemplate}
                                children={<Translate text={'save'}/>}
                            />
                        </div>

                        <br/>
                        <br/>

                        <Separator/>

                        <br/>

                        <ImportTemplates user={user} clients={clients} folders={[]}
                                         onImport={handleImportTemplate}/>

                        <br/>
                        <br/>

                        <Separator/>

                        <div
                            style={{
                                marginTop: "20px",
                                maxWidth: "100%",
                                maxHeight: "600px",
                                overflow: "auto",
                                width: "100%",
                                display: "flex",
                                alignItems: "flex-start",
                                flexDirection: "row",
                                flexWrap: "wrap",
                                gap: "20px",
                                padding: "20px",
                                justifyContent: "space-evenly",
                            }}
                        >
                            {Object.entries(groupedTemplates).map(([folderName, folderTemplates]) => (
                                <div
                                    key={folderName}
                                    onClick={() => handleTemplateFolderClick(folderTemplates, folderName)}
                                    style={{
                                        borderRadius: "12px",
                                        padding: "16px 20px",
                                        backgroundColor: "rgb(221, 228, 246)",
                                        cursor: "pointer",
                                        width: "200px",
                                        minHeight: "120px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                        position: "relative",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 6px 16px rgba(0, 0, 0, 0.1)";
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.05)";
                                        e.currentTarget.style.transform = "translateY(0)";
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                            padding: "10px",
                                            flex: 1,
                                        }}
                                    >
                                        <img width={32} height={32} src={FolderIcon} alt="Folder Icon"/>

                                        <strong
                                            style={{
                                                marginTop: "10px",
                                                fontSize: "15px",
                                                color: "#333",
                                                wordBreak: "break-word",
                                                whiteSpace: "normal",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "100%",
                                            }}
                                        >
                                            {folderName}
                                        </strong>
                                    </div>


                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setNewTemplateFolderName(folderName);
                                            setTimeout(() => {
                                                inputRef.current.scrollIntoView({behavior: 'smooth', block: 'center'});
                                            }, 0);
                                        }}
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            backgroundColor: "#fff",
                                            borderRadius: "50%",
                                            padding: "6px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faPlus} style={{color: "#e63946", fontSize: "14px"}}/>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            )}

            {features.includes(config.features.CATEGORIES) && activeTab === 'categories' && (
                <div className={'bg-white'}>
                    <div className="first-messages-block">

                        <div>
                            <h2 style={{padding: '10px'}} className="configurations-header">
                                <Translate text={'categories'}/>
                            </h2>
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            justifyContent: 'center'
                        }}>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'categoryName'}]}>
                                <Input
                                    maxLength={150}
                                    type="text"
                                    value={newCategory}
                                    onChange={handleInputChange}
                                    onKeyPress={handleKeyPress}
                                    style={{
                                        padding: '10px',
                                        width: '280px',
                                        margin: '10px'
                                    }}
                                />
                            </TranslateProperty>

                            <BlueButton
                                height={'43px'}
                                styles={{fontSize:'11px'}}
                                width={'105px'}
                                onClick={handleAddCategory}
                                children={<Translate text={'add'}/>}
                            />
                        </div>

                        <br/>
                        <Separator/>

                        <div style={{
                            marginTop: '20px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            overflow: 'auto',
                            maxHeight: '380px'
                        }}>
                            {categories.map((category, index) => (
                                <div key={index} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: 'rgb(221, 228, 246)',
                                    borderRadius: '10px',
                                    padding: '10px',
                                    margin: '10px',
                                    flex: '0 0 calc(33.33% - 20px)',
                                    boxSizing: 'border-box',
                                    opacity: visibleCategories[category.name] ? 1 : 0.5
                                }}>
                                    <span style={{flex: 1}}>{category.name}</span>
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            checked={visibleCategories[category.name] || false}
                                            onChange={() => toggleCategoryVisibility(category.name, category.id)}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                    <button className="remove-btn"
                                            onClick={() => handleDeleteCategory(index, category.name)}>
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {features.includes(config.features.SKILLS) && activeTab === 'skills' && (
                <div className={'bg-white'}>
                    <div className="first-messages-block">

                        <div>
                            <h2 style={{padding: '10px'}} className="configurations-header">
                                <Translate text={'skills'}/>
                            </h2>
                            <div style={{
                                ...silverInfoStyles.info,
                                marginLeft: '0px',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}>
                                <Translate text="skillInfo"/>
                            </div>
                        </div>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '20px',
                            justifyContent: 'center'
                        }}>
                            <TranslateProperty properties={[{key: 'placeholder', value: 'skillName'}]}>
                                <Input
                                    maxLength={40}
                                    type="text"
                                    value={newSkill}
                                    onChange={handleSkillInputChange}
                                    style={{
                                        padding: '10px',
                                        width: '280px',
                                        margin: '10px'
                                    }}
                                />
                            </TranslateProperty>
                            <BlueButton
                                height={'43px'}
                                styles={{fontSize:'11px'}}
                                width={'105px'}
                                onClick={handleAddSkill}
                                children={<Translate text={'add'}/>}
                            />
                        </div>

                        <br/>
                        <Separator/>

                        <div style={{
                            marginTop: '20px',
                            display: 'flex',
                            overflow: 'auto',
                            flexWrap: 'wrap',
                            justifyContent: 'center'
                        }}>
                            {skills.map((skill) => (
                                <div key={skill.id} style={{
                                    backgroundColor: 'rgb(221, 228, 246)',
                                    borderRadius: '10px',
                                    padding: '10px',
                                    margin: '10px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    width: '20%',
                                }}>
                                    <input
                                        type="text"
                                        value={skill.name}
                                        onChange={(e) => handleUpdateSkill(skill.id, e.target.value)}
                                        style={{flex: 1, border: 'none', background: 'transparent', width: '100%'}}
                                    />
                                    <button className="remove-btn"
                                            onClick={() => handleDeleteSkill(skill.id)}>
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {features.includes(config.features.WEBHOOKS) && activeTab === 'webhooks' && (
                <div className={'bg-white'}>
                    <div className="first-messages-block">

                        <Webhooks updateWebhooksState={updateWebhooksState}
                                  setUpdateWebhooksState={setUpdateWebhooksState}
                                  client={client} webhooks={webhooks} setWebhooks={setWebhooks} user={user}/>
                    </div>
                </div>
            )}

        </div>
    );
}

const mapDispatchToProps = dispatch => ({
    confirmAction: (obj) => (dispatch(confirmActionRequested(obj.func, obj.args, obj.onCancel, obj.onCancelArgs, obj.content))),
});


export default connect(null, mapDispatchToProps)(Resources);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Resources.jsx